"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ItemList = require("./ItemList");
var _Image360Item = require("./ItemList/Image360Item");
var _ImageItem = require("./ItemList/ImageItem");
var _VideoItem = require("./ItemList/VideoItem");
var _MobileMenu = require("./MobileMenu");
var _ThumbnailList = require("./ThumbnailList");
var _Title = require("./Title");
var Body = function Body(props) {
  var isMobile = props.isMobile,
    isPreview = props.isPreview,
    onItemClick = props.onItemClick,
    title = props.title,
    totalItemCount = props.totalItemCount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Gallery-Body"
  }, !isPreview && /*#__PURE__*/_react["default"].createElement(_Title.Title, null, title), !isPreview && isMobile && /*#__PURE__*/_react["default"].createElement(_MobileMenu.MobileMenu, props), /*#__PURE__*/_react["default"].createElement(_ItemList.ItemList, props), totalItemCount > 1 && /*#__PURE__*/_react["default"].createElement(_ThumbnailList.ThumbnailList, (0, _extends2["default"])({}, props, {
    onMoreThumbnailClick: onItemClick
  })));
};
exports.Body = Body;
Body.defaultProps = {
  Image360ItemComponent: _Image360Item.Image360Item,
  ImageItemComponent: _ImageItem.ImageItem,
  VideoItemComponent: _VideoItem.VideoItem
};